import { useState, useCallback } from 'react';

/**
 * Hook to track search queries and results for feedback functionality
 */
export const useSearchTracking = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [selectedResult, setSelectedResult] = useState(null);

  const trackSearch = useCallback((query, results) => {
    setSearchQuery(query);
    setSearchResults(results);
  }, []);

  const trackSelection = useCallback((result) => {
    setSelectedResult(result);
  }, []);

  const clearTracking = useCallback(() => {
    setSearchQuery('');
    setSearchResults([]);
    setSelectedResult(null);
  }, []);

  return {
    searchQuery,
    searchResults,
    selectedResult,
    trackSearch,
    trackSelection,
    clearTracking
  };
};

